import * as svg from "../../../assets/file-download-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const FileDownloadIcon = iconBuilder(svg, "FileDownloadIcon", "0 0 20 20");
